import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import posthog from 'posthog-js'
import { environment } from './environments/environment';

if (environment.production) {
  posthog.init(
    //@ts-ignore
    environment.POSTHOG_KEY,
    {
      //@ts-ignore
      api_host: environment.POSTHOG_HOST,
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      enable_heatmaps: true,
    }
  )
}


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
